import type { ReactNode } from 'react';
import { m } from 'motion/react';
import { TableRow } from '../ui/table';

const MotionTableRow = m.create(TableRow);

/**
 * Work-item table row that fades in when an item is added and fades out when it
 * is archived or deleted, with the remaining rows sliding up to close the gap.
 *
 * Must be rendered inside an `AnimatePresence` and keyed by work item id — the
 * exit animation is silently skipped otherwise. The surrounding list must also
 * stay mounted while the item is removed, so refetches triggered by archive or
 * delete need to be silent rather than swapping in a loading skeleton.
 */
export default function WorkItemTableRow({
  workItemId,
  children,
}: {
  workItemId: string;
  children: ReactNode;
}) {
  return (
    <MotionTableRow
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      id={`issue-${workItemId}`}
      tabIndex={-1}
    >
      {children}
    </MotionTableRow>
  );
}
